import type { Theme } from '@core/entities/Theme';
import type { ThemeRepository } from '@core/repositories/ThemeRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface ThemeResponse {
  id: string;
  name: string;
  slug: string;
  mode: 'light' | 'dark';
  colors: Record<string, string>;
  is_default: boolean;
  is_custom: boolean;
}

interface ThemeEnvelope {
  data: ThemeResponse[];
}

export class ThemeRepositoryImpl implements ThemeRepository {
  async list(): Promise<Theme[]> {
    try {
      const response = await httpClient.get<ThemeEnvelope>('/themes');
      return response.data.data.map((theme) => ({
        id: theme.id,
        name: theme.name,
        slug: theme.slug,
        mode: theme.mode,
        colors: theme.colors,
        isDefault: theme.is_default,
        isCustom: theme.is_custom,
      }));
    } catch (error) {
      throw toAppError(error);
    }
  }
}
